import Vue from 'vue';
import CircleProgress from 'vue2-circle-progress/src/index.vue'

Vue.component('CircleProgress', CircleProgress)
